import axios from 'axios';
const instance = axios.create({baseURL: `${window.Configs['admin-base-url']}`});
export default instance